<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates38">
<p class="centerImage"><img alt="images" id="plate38" src="images/plate38.jpg"/></p>
<p class="caption">Out in the bush – Darwin 1943.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates38.vue?634f516e